export default __webpack_public_path__ + "static/media/facebook.3bca0d6b.svg";